// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide scrollbar for Chrome, Safari and Opera */
.example2::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example2 {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.addRole {
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  text-decoration: none;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
}

.buttonAddRole {
  align-items: center;
  background-color: #5d87ff;
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;

  font-weight: 500;
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 1em;
  padding: 10px 15px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}

/* input */

.labelVal {
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}
.inputField {
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;

  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}

.errorMsg {
  font-weight: 600;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;

  color: red;
}

.inputFieldError {
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;

  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid red;
  outline: 1px solid red;
}

.inputFieldForPass {
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;

  padding: 0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
}

.disableInput {
  background: rgb(219, 218, 218);
  font-family: "Montserrat", sans-serif;

  cursor: not-allowed;
}

.passWrapper {
  position: relative;
  font-family: "Montserrat", sans-serif;
}
.eyeIcon {
  cursor: pointer;
  position: absolute;
  top: 13px;
  right: 10px;
}

.inputFieldForPass:focus {
  outline: 2px solid rgb(195, 193, 193);
}
.inputField:focus {
  outline: 2px solid rgb(195, 193, 193);
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed !important;
}

@media only screen and (max-width: 600px) {
  .draggDownBox {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .draggDownBox2 {
    width: 100%;
  }
}



.card1 {
  width: 330px;
  height: 80px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px 15px;
  background-color: #ffffff;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 15px;
}
.wave1 {
  position: absolute;
  transform: rotate(90deg);
  left: -31px;
  top: 32px;
  width: 80px;
  fill: #04e4003a;
}
.icon-container1 {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #04e40048;
  border-radius: 50%;
  margin-left: 8px;
}
.icon1 {
  width: 17px;
  height: 17px;
  color: #269b24;
}
.message-text-container1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
}
.message-text1,
.sub-text1 {
  margin: 0;
  cursor: default;
}
.message-text1 {
  color: #269b24;
  font-size: 17px;
  font-weight: 700;
}
.sub-text1 {
  font-size: 14px;
  color: #555;
  font-weight: 800;
}


.loader10 {
  --w:10ch;
  font-weight: bold;
  font-family: monospace;
  font-size: 30px;
  letter-spacing: var(--w);
  width: var(--w);
  overflow: hidden;
  white-space: nowrap;
  color: #0000;
  animation: l40 2s infinite;
}
.loader10:before {
  content:"Loading...";
}

@keyframes l40{
  0%,100% {
   text-shadow: 
        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) 0 #000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) 0 #000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;
  }
  9% {
   text-shadow: 
        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) 0 #000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;
  }
  18% {
   text-shadow: 
        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;
  }
  27% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;
  }
  36% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;
  }
  45% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) 0 #000;
  }
  54% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) 0 #000;
  }
  63% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;
  }
  72% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;
  }
  81% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) -20px #0000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;
  }
  90% {
   text-shadow: 
        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) -20px #0000,calc(-4*var(--w)) -20px #0000, 
        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) -20px #0000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAIA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,qCAAqC;;EAErC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA,UAAU;;AAEV;EACE,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;;EAErC,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;;EAErC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;;EAErC,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;;EAErC,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;;EAErC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;;;AAIA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE;GACC;;oIAEiI;EAClI;EACA;GACC;;oIAEiI;EAClI;EACA;GACC;;yIAEsI;EACvI;EACA;GACC;;yIAEsI;EACvI;EACA;GACC;;8IAE2I;EAC5I;EACA;GACC;;mJAEgJ;EACjJ;EACA;GACC;;mJAEgJ;EACjJ;EACA;GACC;;wJAEqJ;EACtJ;EACA;GACC;;wJAEqJ;EACtJ;EACA;GACC;;6JAE0J;EAC3J;EACA;GACC;;6JAE0J;EAC3J;AACF","sourcesContent":["/* Hide scrollbar for Chrome, Safari and Opera */\n.example2::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.example2 {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600&display=swap\");\n\n.addRole {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 20px;\n  text-decoration: none;\n  cursor: pointer;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.buttonAddRole {\n  align-items: center;\n  background-color: #5d87ff;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-family: \"Montserrat\", sans-serif;\n\n  font-weight: 500;\n  display: flex;\n  font-size: 14px;\n  justify-content: center;\n  line-height: 1em;\n  padding: 10px 15px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n  width: fit-content;\n}\n\n/* input */\n\n.labelVal {\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n}\n.inputField {\n  width: 100%;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n\n.errorMsg {\n  font-weight: 600;\n  font-size: 14px;\n  font-family: \"Montserrat\", sans-serif;\n\n  color: red;\n}\n\n.inputFieldError {\n  width: 100%;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid red;\n  outline: 1px solid red;\n}\n\n.inputFieldForPass {\n  width: 100%;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  font-family: \"Montserrat\", sans-serif;\n\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n}\n\n.disableInput {\n  background: rgb(219, 218, 218);\n  font-family: \"Montserrat\", sans-serif;\n\n  cursor: not-allowed;\n}\n\n.passWrapper {\n  position: relative;\n  font-family: \"Montserrat\", sans-serif;\n}\n.eyeIcon {\n  cursor: pointer;\n  position: absolute;\n  top: 13px;\n  right: 10px;\n}\n\n.inputFieldForPass:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n.inputField:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n\n.disabled {\n  opacity: 0.4;\n  cursor: not-allowed !important;\n}\n\n@media only screen and (max-width: 600px) {\n  .draggDownBox {\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .draggDownBox2 {\n    width: 100%;\n  }\n}\n\n\n\n.card1 {\n  width: 330px;\n  height: 80px;\n  border-radius: 8px;\n  box-sizing: border-box;\n  padding: 10px 15px;\n  background-color: #ffffff;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 15px;\n}\n.wave1 {\n  position: absolute;\n  transform: rotate(90deg);\n  left: -31px;\n  top: 32px;\n  width: 80px;\n  fill: #04e4003a;\n}\n.icon-container1 {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #04e40048;\n  border-radius: 50%;\n  margin-left: 8px;\n}\n.icon1 {\n  width: 17px;\n  height: 17px;\n  color: #269b24;\n}\n.message-text-container1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex-grow: 1;\n}\n.message-text1,\n.sub-text1 {\n  margin: 0;\n  cursor: default;\n}\n.message-text1 {\n  color: #269b24;\n  font-size: 17px;\n  font-weight: 700;\n}\n.sub-text1 {\n  font-size: 14px;\n  color: #555;\n  font-weight: 800;\n}\n\n\n.loader10 {\n  --w:10ch;\n  font-weight: bold;\n  font-family: monospace;\n  font-size: 30px;\n  letter-spacing: var(--w);\n  width: var(--w);\n  overflow: hidden;\n  white-space: nowrap;\n  color: #0000;\n  animation: l40 2s infinite;\n}\n.loader10:before {\n  content:\"Loading...\";\n}\n\n@keyframes l40{\n  0%,100% {\n   text-shadow: \n        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) 0 #000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) 0 #000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;\n  }\n  9% {\n   text-shadow: \n        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) 0 #000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;\n  }\n  18% {\n   text-shadow: \n        calc( 0*var(--w)) 0 #000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;\n  }\n  27% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) 0 #000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;\n  }\n  36% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) 0 #000,calc(-9*var(--w)) 0 #000;\n  }\n  45% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) 0 #000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) 0 #000;\n  }\n  54% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) 0 #000;\n  }\n  63% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) 0 #000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;\n  }\n  72% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) 0 #000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;\n  }\n  81% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) 0 #000,calc(-4*var(--w)) -20px #0000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) -20px #0000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;\n  }\n  90% {\n   text-shadow: \n        calc( 0*var(--w)) -20px #0000,calc(-1*var(--w)) -20px #0000,calc(-2*var(--w)) -20px #0000,calc(-3*var(--w)) -20px #0000,calc(-4*var(--w)) -20px #0000, \n        calc(-5*var(--w)) -20px #0000,calc(-6*var(--w)) -20px #0000,calc(-7*var(--w)) -20px #0000,calc(-8*var(--w)) -20px #0000,calc(-9*var(--w)) -20px #0000;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
